// TextBoxS is for search.  got too lazy to make all the changes to regular textbox 

import React, { useContext } from 'react'
import Tippy from '@tippyjs/react'
import { UserContext } from './UserContext'

const TextBoxS = ({ tooltipContent, name, text, width, curText, handleOnChange }) => {

    const { browserH, browserW, rdd, globalTextSize } = useContext(UserContext)

    var searchTextBoxWidth = 24;
    var textBoxHeight = '2.7vh'


    if      (rdd.isMobile && !rdd.isTablet && browserH > browserW) {textBoxHeight = '3.8vh'; searchTextBoxWidth=16;}
    else if (rdd.isMobile && !rdd.isTablet && browserH < browserW) { textBoxHeight = '7.8vh'; }
    else if (rdd.isMobile && rdd.isTablet && browserH > browserW) { textBoxHeight = '3.8vh'; }
    else if (rdd.isMobile && rdd.isTablet && browserH < browserW) { }




    // if (rdd.isMobile) {
    //     if (browserH > browserW) {
    //         if (rdd.isTablet) {
    //         }
    //         else {
    //             textBoxHeight = '3.8vh'
    //         }
    //     }
    //     else { // landscape
    //         if (rdd.isTablet) {
    //         }
    //         else {
    //             textBoxHeight = '7.8vh'
    //         }
    //     }
    // }



    var ttc = '';
    var ttp = 'right';
    if (tooltipContent !== undefined) {
        ttc = tooltipContent.slice(2);
        switch (tooltipContent.substring(0, 1)) {
            case 'r': ttp = 'right'; break;
            case 'l': ttp = 'left'; break;
            case 't': ttp = 'top'; break;
            case 'b': ttp = 'bottom'; break;
            default:break;
        }
    }

    return (

        <Tippy placement={ttp} content={
            <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                {ttc}
            </div>
        }>

            <div>
                <input type="text" value={curText} onChange={handleOnChange} size={searchTextBoxWidth} name={name} id={name} style={{ fontSize: globalTextSize, height: textBoxHeight }} />
            </div>
        </Tippy>
    )
}

export default TextBoxS
